import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY as CATEGORIES_QUERY_KEY } from '../../../queries/useGetCategories.query';
import { CategoryTypeDto } from '../../../Services.types';
import { QUERY_KEY as SERVICES_QUERY_KEY } from '../../CategoryCard/queries/useGetServicesByCategory.query';
import { CreateServiceFormValues } from '../ServiceModal.types';

interface UpdateServiceParams {
  id: string;
  payload: CreateServiceFormValues;
}

const useUpdateServiceQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    ({ id, payload }: UpdateServiceParams) =>
      api.patch(API_URL.SERVICES_BY_ID(id), {
        name: payload.name,
        category_type: payload.categoryType as CategoryTypeDto,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [CATEGORIES_QUERY_KEY] });
        queryClient.invalidateQueries({ queryKey: [SERVICES_QUERY_KEY] });
      },
    }
  );

  const handleUpdate = useCallback(
    async (id: string, payload: CreateServiceFormValues) => {
      await mutateAsync({ id, payload });
    },
    [mutateAsync]
  );

  return { handleUpdate, isLoading };
};

export default useUpdateServiceQuery;
